import React from 'react'
import './TextBlock.scss'

const TextBlock = ({ block }) => {
  return (
    <div className="block block-text">
      {block.Heading && <h2>{block.Heading}</h2>}
      {block.Content && (
        <div dangerouslySetInnerHTML={{ __html: block.Content }} />
      )}
    </div>
  )
}

export default TextBlock
